export const FETCH_BULK_ERROR_DOWNLOAD_SUCCESS = 'FETCH_BULK_ERROR_DOWNLOAD_SUCCESS';
export const FETCH_BULK_ERROR_DOWNLOAD_REQUEST = 'FETCH_BULK_ERROR_DOWNLOAD_REQUEST';
export const FETCH_BULK_ERROR_DOWNLOAD_FAILURE = 'FETCH_BULK_ERROR_DOWNLOAD_FAILURE';
export const FETCH_BULK_ERROR_DOWNLOAD_REST = 'FETCH_BULK_ERROR_DOWNLOAD_REST';
export const fetchBulkErrorDownloadSuccess = (payload) => ({
    type: FETCH_BULK_ERROR_DOWNLOAD_SUCCESS,
    payload,
});
export const fetchBulkErrorDownloadRequest = (payload) => ({
    type: FETCH_BULK_ERROR_DOWNLOAD_REQUEST,
    payload,
});
export const fetchBulkErrorDownloadFailure = (payload) => ({
    type: FETCH_BULK_ERROR_DOWNLOAD_FAILURE,
    payload,
});
export const fetchBulkErrorDownloadReset = () => ({
    type: FETCH_BULK_ERROR_DOWNLOAD_REST,
});
